import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ToastProvider } from './components/Toast';
import ProtectedRoute from './auth/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';
import AgentsPage from './Pages/AgentsPage';
import AccountsPage from './Pages/AccountsPage';
import ActivitiesPage from './Pages/ActivitiesPage';
import AuditLogPage from './Pages/AuditLogPage';
import ContactsPage from './Pages/ContactsPage';
import DashboardPage from './Pages/DashboardPage';
import LeadFormPage from './Pages/LeadFormPage';
import LeadEditPage from './Pages/LeadEditPage';
import LeadsPage from './Pages/LeadsPage';
import LoginPage from './Pages/LoginPage';
import NotFoundPage from './Pages/NotFoundPage';
import ReportsPage from './Pages/ReportsPage';
import SettingsPage from './Pages/SettingsPage';
import SignupPage from './Pages/SignupPage';
import TasksPage from './Pages/TasksPage';
import AssignmentRulesPage from './Pages/AssignmentRulesPage';
import QueuesPage from './Pages/QueuesPage';
import QueueWorklistPage from './Pages/QueueWorklistPage';
import './styles/lms.css';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Lead management */}
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/leads/new" element={<LeadFormPage />} />
          <Route path="/leads/:id/edit" element={<LeadEditPage />} />

          {/* Agent management */}
          <Route
            path="/agents"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <AgentsPage />
              </ProtectedRoute>
            )}
          />

          {/* Assignment engine */}
          <Route
            path="/assignment-rules"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <AssignmentRulesPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/queues"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <QueuesPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/queue-worklist"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager", "agent"]}>
                <QueueWorklistPage />
              </ProtectedRoute>
            )}
          />

          {/* Reporting */}
          <Route
            path="/reports"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <ReportsPage />
              </ProtectedRoute>
            )}
          />

          {/* Compliance */}
          <Route
            path="/audit-log"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <AuditLogPage />
              </ProtectedRoute>
            )}
          />

          {/* Account / profile settings */}
          <Route
            path="/settings"
            element={(
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <SettingsPage />
              </ProtectedRoute>
            )}
          />

          {/* Placeholder sections — to be built iteratively */}
          <Route
            path="/accounts"
            element={<AccountsPage />}
          />
          <Route
            path="/contacts"
            element={<ContactsPage />}
          />
          <Route
            path="/activities"
            element={<ActivitiesPage />}
          />
          <Route
            path="/tasks"
            element={<TasksPage />}
          />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
    </ToastProvider>
  );
}

export default App;
